import { get, forEach } from 'lodash';
import { MessageFromBE } from './types';

interface IMessage extends Pick<MessageFromBE, 'retry' | 'channel' | 'externalStatus' | '_id'> {}

export const DEFAULT_REASON = 'This message could not be delivered';

interface RetriedItem {
  id: string;
  count: number;
  channels: { name: string; reason: string }[];
}
interface LastRetriedObject {
  [key: string]: RetriedItem;
}

const makeChannel = (item: IMessage) => ({
  name: item.channel ?? '',
  reason: item.externalStatus?.reason ?? DEFAULT_REASON,
});

function getLastRetriedMessagesObject<T extends IMessage>(messages: T[], originalMessages: T[]) {
  const countObject: LastRetriedObject = {};

  const retriedMessages = messages.filter((item) => !!item.retry?.originalMessage);

  forEach(originalMessages, (item) => {
    countObject[item._id] = {
      id: item._id,
      count: 0,
      channels: [makeChannel(item)],
    };
  });

  forEach(retriedMessages, (item) => {
    const itemRetry = get(item, 'retry');
    const itemKey = get(itemRetry, 'originalMessage', 'none');
    const itemCount = get(itemRetry, 'count', 0);

    const countObjectItem: RetriedItem | undefined = get(countObject, itemKey);
    const countObjectItemCount = get(countObjectItem, 'count', 0);
    const countObjectItemChannels = get(countObjectItem, 'channels', []);

    const isGreater = itemCount > countObjectItemCount;
    const currentChannels = countObjectItemChannels;
    if (isGreater) {
      countObject[itemKey] = {
        id: item._id,
        count: itemCount,
        channels: [...currentChannels, makeChannel(item)],
      };
      return null;
    }
    return null;
  });

  return countObject;
}

export default getLastRetriedMessagesObject;
